import React from 'react';

const FolderIcon = () => {
  return (
    <svg
      width="84"
      height="67"
      viewBox="0 0 84 67"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 66V66.5H1.5H82.5H83V66V10.1765V9.67647H82.5H47.6563L38.4561 0.643223L38.3102 0.5H38.1058H10.0673H9.86288L9.71701 0.643223L1.1497 9.05499L1 9.20197V9.41177V66Z"
        stroke="#C4964D"
      />
      <g filter="url(#filter0_i_2000_103835)">
        <path
          d="M4.8891 63.2917V9.82457L11.3284 4.04688H37.5094L46.7448 13.0334H79.4498V63.2917H4.8891Z"
          fill="#1C5762"
        />
      </g>
      <path
        d="M4.8891 63.2917V9.82457L11.3284 4.04688H37.5094L46.7448 13.0334H79.4498V63.2917H4.8891Z"
        stroke="#18B5BD"
      />
      <path
        d="M68.6046 15.2188L77.4163 15.2188V24.0208L73.0105 19.6198L68.6046 15.2188Z"
        fill="#C4964D"
      />
      <g clipPath="url(#clip0_2000_103835)">
        <mask
          id="mask0_2000_103835"
          maskUnits="userSpaceOnUse"
          x="23"
          y="19"
          width="38"
          height="38"
        >
          <rect
            x="23.5909"
            y="19.6521"
            width="36.8182"
            height="36.7391"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask0_2000_103835)">
          <path
            d="M38.2414 47.2064L29.4971 38.4809L31.6832 36.2995L38.2414 42.8436L52.3167 28.7986L54.5028 30.98L38.2414 47.2064Z"
            fill="#18B5BD"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_i_2000_103835"
          x="4.3891"
          y="3.54688"
          width="75.5607"
          height="60.2449"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="6.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.313726 0 0 0 0 0.917647 0 0 0 0 0.917647 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_2000_103835"
          />
        </filter>
        <clipPath id="clip0_2000_103835">
          <rect
            width="36.8182"
            height="36.7391"
            fill="white"
            transform="translate(23.5909 19.6521)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default FolderIcon;
